import { map } from "ramda";

export interface IImpactRangeConstructorParams {
	from: number;
	to: number;
	level: string;
	levelText: string;
	headline: string;
	text: string;
}

class ImpactRange {
	public static Default: ImpactRange = ImpactRange.Construct({
		from: 0,
		level: "Eco-Enthusiast",
		levelText:
			"This month we’ve saved emissions equal to a typical SYD to MEL flight (3t CO₂).",
		headline: "Nice one! You're a Planet Pioneer.",
		text: "You’ve planted 6 trees! Enough to offset the emissions generated by a SYD to MEL flight (3t CO₂).",
		to: 0,
	});

	public static ConstructList(
		arrParams: Array<IImpactRangeConstructorParams>,
	): Array<ImpactRange> {
		return map(ImpactRange.Construct)(arrParams);
	}

	public static Construct(params: IImpactRangeConstructorParams): ImpactRange {
		return new ImpactRange(params);
	}

	responseData: IImpactRangeConstructorParams;

	constructor(params: IImpactRangeConstructorParams) {
		this.responseData = params;
	}

	isInRange(loyaltyPoints: number): boolean {
		if (this.to === null) {
			return loyaltyPoints >= this.from;
		}

		return this.from <= loyaltyPoints && loyaltyPoints <= this.to;
	}

	get from(): number {
		return this.responseData.from;
	}

	get to(): number | null {
		if (this.responseData.to === undefined) {
			return null;
		}

		return this.responseData.to;
	}

	get level(): string {
		return this.responseData.level;
	}

	get levelText(): string {
		return this.responseData.levelText;
	}

	get headline(): string {
		return this.responseData.headline;
	}

	get text(): string {
		return this.responseData.text;
	}
}

export default ImpactRange;
